var map = {
	"./asset-hyperlink.json": 1496,
	"./blockquote.json": 1497,
	"./document.json": 1498,
	"./embedded-asset-block.json": 1499,
	"./embedded-entry-block.json": 1500,
	"./embedded-entry-inline.json": 1501,
	"./embedded-resource-block.json": 1502,
	"./embedded-resource-inline.json": 1503,
	"./entry-hyperlink.json": 1504,
	"./heading-1.json": 1505,
	"./heading-2.json": 1506,
	"./heading-3.json": 1507,
	"./heading-4.json": 1508,
	"./heading-5.json": 1509,
	"./heading-6.json": 1510,
	"./hr.json": 1511,
	"./hyperlink.json": 1512,
	"./list-item.json": 1513,
	"./ordered-list.json": 1514,
	"./paragraph.json": 1515,
	"./resource-hyperlink.json": 1516,
	"./table-cell.json": 1517,
	"./table-header-cell.json": 1518,
	"./table-row.json": 1519,
	"./table.json": 1520,
	"./text.json": 1521,
	"./unordered-list.json": 1522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1495;